import firebase from 'firebase/app';
import { decompress } from 'compress-json'
import { nanoid } from 'nanoid';
import axios from 'axios';
import moment from 'moment';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/messaging';
import 'firebase/functions';
import 'firebase/storage';
import 'firebase/auth';
import _ from 'lodash';
// FUNCTION WHICH WILL CALL TO DB

// firebase config
var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
firebase.initializeApp(firebaseConfig);

const app = firebase.app();
const functions = app.functions("europe-west1");

// DB Route
const db = firebase.database();
// firestore Route
const fsdb = firebase.firestore();
// Auth Route
const auth = firebase.auth();
export const firebaseFunctions = functions;

// send sample email HTTPS function
export function sendSampleEmail(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('sendSampleEmail');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('sample email error: ', error);
        reject(error);
      });
  });
};

// get size of folder in firebase storage
export function getFileSize(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getFolderSizes');
    console.log('called')
    https(data)
      .then(function (result) {
        var responseData = result.data;
        console.log('responseData',responseData)
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('sample email error: ', error);
        reject(error);
      });
  });
};

// getFileSize({path:"-O2yxToPdTQgIp0Wyd4h/"})

// check company storage limit before uploading file
export function checkStorageLimit(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('checkStorageLimit');

    https(data)
      .then(function (result) {
        var allowed = result.data.allowed;
        var message = result.data.message;
        resolve({allowed,message});
      })
      .catch(function (error) {
        console.log('checkStorageLimit error: ', error);
        reject(error.message);
      });
  });
};

// get customer relevant bookings / kids
export function getCustomerRelevantInfo(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getCustomerRelevantInfo');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('getCustomerRelevantInfo error: ', error);
        reject(error);
      });
  });
};

// get company customers
export function getCustomersList(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getCompanyCustomers');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('getCustomersList error: ', error);
        reject(error);
      });
  });
};

export function generateSignedUrl(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('generateSignedUrl');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        console.log('responseData',responseData)
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('sample email error: ', error);
        reject(error);
      });
  });
};

// generateSignedUrl({originalUrl:'https://firebasestorage.googleapis.com/v0/b/selynk-uk.appspot.com/o/-Ns3w0oSv2kd5ZKfmVyS%2FCourses%2F-NsCcb3-8swcKE05R3Vv%2FContents%2F6d726545-e305-4262-ba96-d607f010d47c?alt=media&token=2a4fa0c8-0e03-4fb7-a6c1-491780070673'});

export function getStartedGenWebsite(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('generatewebsitePartnerGetStarted');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('getStartedGenWebsite error: ', error);
        reject(error.message);
      });
  });
};

// create video live session via page /online-sessions is can only be created by partner
export function partnerCreateVideoSession(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('partnerCreateLiveSession');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('partnerCreateVideoSession error: ', error);
        reject(error.message);
      });
  });
};

export function winnerEmail(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('winner');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('sample email error: ', error);
        reject(error);
      });
  });
};

// winnerEmail();

export function duplicateService(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('duplicateService');

    https(data)
      .then(function (result) {
        var message = result.data['message'];
        resolve(message);
      })
      .catch(function (error) {
        console.log('duplicate service error: ', error);
        reject(error.message);
      });
  });
}

// resend reservation confirmation using report page
export function sendBookingConfirmation(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('resendBookingConfirmationEmail');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('sample email error: ', error);
        reject(error);
      });
  });
};

// send lms credential via email
export function sendLmsCredentialEmail(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('sendLMSCredentialViaEmail');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('sample email error: ', error);
        reject(error);
      });
  });
};

export function addAudio({ file, senderId, chatroomId }) {
  const musicRef = firebase
    .storage()
    .ref(`ChatAttachments/audio/${chatroomId}/${file.name}`);
  let metadata = {
    customMetadata: {
      senderId: senderId,
      chatroomId: chatroomId,
    },
  };
  musicRef.put(file, metadata).then(() => {
    musicRef.getDownloadURL().then(function (url) {
      console.log('URL', url);
    });
  });
}

export function chatAddVideo({ file, senderId, chatroomId }) {
  const videoRef = firebase
    .storage()
    .ref(`ChatAttachments/videos/${chatroomId}/${nanoid()}`);

  let metadata = {
    customMetadata: {
      senderId: senderId,
      chatroomId: chatroomId,
    },
  };
  videoRef.put(file, metadata).then(() => {
    videoRef.getDownloadURL().then(function (url) {
      console.log('URL', url);
    });
  });
}

export function addImg({ file, senderId, chatroomId }) {
  const imageRef = firebase
    .storage()
    .ref(`ChatAttachments/images/${chatroomId}/${file.name}`);

  let metadata = {
    customMetadata: {
      senderId: senderId,
      chatroomId: chatroomId,
    },
  };
  imageRef.put(file, metadata).then(() => {
    imageRef.getDownloadURL().then(function (url) {
      console.log('URL', url);
    });
  });
}

export function addDoc({ file, senderId, chatroomId }) {
  const docRef = firebase
    .storage()
    .ref(`ChatAttachments/files/${chatroomId}/${file.name}`);

  let metadata = {
    customMetadata: {
      senderId: senderId,
      chatroomId: chatroomId,
    },
  };
  docRef
    .put(file, metadata)
    .then(() => {
      docRef.getDownloadURL().then(function (url) {
        console.log('URL', url);
      });
    })
    .catch((e) => {
      console.log(e);
    });
}

// Analytic generater function
function generatePartnerReport(obj) {
  return new Promise((resolve, reject) => {
    var generatePartnerReport = functions.httpsCallable('generatePartnerReport');

    generatePartnerReport(obj)
      .then(function (result) {
        // Read result of the Cloud Function.
        var sanitizedMessage = result.data;
        resolve(sanitizedMessage);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
};

function setReservationDates(data) {
  return new Promise((resolve, reject) => {
    var newClassHttps = functions.httpsCallable('setReservationDate');

    newClassHttps(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('set reservations date error: ', error);
        var message = error;
        reject(message);
      });
  });
}

export function getCompaniesList() {
  return new Promise((resolve, reject) => {
    var Https = functions.httpsCallable('getCompaniesList');

    Https()
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('get companies data error: ', error);
        var message = error;
        reject(message);
      });
  });
}

function createNewZoomClass(data) {
  return new Promise((resolve, reject) => {
    var newClassHttps = functions.httpsCallable('createNewZoomClass');

    newClassHttps(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('creating zoom new class error:', error);
        var message = error;
        reject(message);
      });
  });
}

function deleteZoomMeeting(data) {
  return new Promise((resolve, reject) => {
    var deleteHttps = functions.httpsCallable('deleteZoomMeeting');

    deleteHttps(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('zoom class delete error:', error);
        var message = error;
        reject(message);
      });
  });
}

// get admin reservation from backend
function allReservation(type) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getAdminReservation');

    https({ type })
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('get admin reservation error:', error);
        var message = error;
        reject(message);
      });
  });
}

export function allFilterReservation(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getAdminFilterReservation', {timeout: 540000});

    https(data)
      .then(async function (result) {
        var responseData = result.data;
        let reversed = decompress(responseData);
        resolve(reversed);
      })
      .catch(function (error) {
        console.log('get admin reservation error:', error);
        var message = error;
        reject(message);
      });
  });
}

// get specific admin reservation from backend
function newSpecificReservation(countryCode, type) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getSpecificAdminReservation');

    https({ countryCode, type })
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('get specific admin reservation error:', error);
        var message = error;
        reject(message);
      });
  });
};

// Create new stripe subscription and customer
export function createSub(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('createStripeSubscription');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};

// stripe subscription
export function createParentSub(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('createBookingStripeSubscription');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
}

// create new subscription only for exist customerId
export function createSubOnly(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('createStripeSubscriptionOnly');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
}

// get parent active booking
export function getParentActiveBooking(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('getParentBooking');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};

// send parent signin otp
export function generateSigninOTP(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('sendParentOTP');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};

// send parent signup otp
export function sendSignupOtp(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('sendSignupOtp');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};

// cloudflare R2 storage events
// function to upload file to cloudflare R2
export function cloudFlareR2Upload(data) {
  return new Promise(async (resolve, reject) => {
    const base64 = await fileToBase64(data.file);
    var Http = functions.httpsCallable('cloudFlareR2FileUpload');
    Http({...data,base64})
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};

export function cloudFlareSignUrl(data) {
  return new Promise(async (resolve, reject) => {
    var Http = functions.httpsCallable('getR2SignedUrl');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var {url} = result.data;
        resolve(url);
      })
      .catch(function (error) {
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};

// function to delete file from cloudflare R2
export function cloudFlareR2Delete(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('cloudFlareR2DeleteFile');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result.split(',')[1]; // Remove the data mime prefix
      resolve(base64);
    };
    reader.onerror = reject;
  });
}

// send parent notification email via appointment page
export function sendParentAppointmentEmail(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('parentAppointmentNotification');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
};



// verify parent otp
export function verifySigninOTP(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('verifyParentOtp');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error message',message)
        var message = error.message;
        reject(message);
      });
  });
};

export function getOnlineSessions(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('getOnlineSessions');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
}

// Update stripe subscription
export function updateSub(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('updateStripeSubscription');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
}

// Get stripe subscription Info
export function getStripeSubscriptionInfo(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('retrieveStripeSubscription');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        console.log('error message',message)
        reject(message);
      });
  });
}

// stripe subscription intent
export function subscriptionRequestIntent(data) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('subscriptionRequestIntent');
    let dataObject = {
      apikey: data.apikey,
      email: data.email,
      parentId: data.parentId,
      companyId: data.companyId,
    };
    emailHttp(dataObject)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}


// stripe payment intent production
function paymentIntent(data) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('stripePaymentIntent');
    let dataObject = {
      amount: data.amount,
      currency: data.currency,
      email: data.email,
      parentId: data.parentId,
      companyId: data.companyId,
      note: data.note,
      includeParent: data.includeParent,
      groupId: data.groupId,
      partnerId: data.partnerId,
      serviceId: data.serviceId,
      kidIds: data.kidIds,
      voucherCode: data.voucherCode,
      parentPhoneNo: data.parentPhoneNo,
      kidNames: data.kidNames,
      pathURL: data.pathURL,
      user: data.user,
      isAnonymous: data.isAnonymous,
      apikey: data.apikey,
      campus: data.campus,
      gradeApplying: data.gradeApplying,
      devision: data.devision,
      // subscription billing
      companyName: data.companyName,
      address: data.address,
      countryCode: data.countryCode,
      city: data.city,
      postalCode: data.postalCode,
      planId: data.planId,
      prevReservationId: data.prevReservationId,
      reservationArray: data.reservationArray,
      // create subscription
      createSubscription: data.createSubscription,
    };
    emailHttp(dataObject)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

export function paymentIntents(data) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('stripePaymentIntent');
    let dataObject = {
      amount: data.amount,
      currency: data.currency,
      email: data.email,
      parentId: data.parentId,
      companyId: data.companyId,
      note: data.note,
      includeParent: data.includeParent,
      groupId: data.groupId,
      partnerId: data.partnerId,
      serviceId: data.serviceId,
      kidIds: data.kidIds,
      voucherCode: data.voucherCode,
      parentPhoneNo: data.parentPhoneNo,
      kidNames: data.kidNames,
      pathURL: data.pathURL,
      user: data.user,
      isAnonymous: data.isAnonymous,
      apikey: data.apikey,
      campus: data.campus,
      gradeApplying: data.gradeApplying,
      devision: data.devision,
      // subscription billing
      companyName: data.companyName,
      address: data.address,
      countryCode: data.countryCode,
      city: data.city,
      postalCode: data.postalCode,
      planId: data.planId,
      prevReservationId: data.prevReservationId
    };
    emailHttp(dataObject)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        console.log('error Message',error.message)
        var message = error;
        reject(message);
      });
  });
}

// stripe payment intent test keys
export function paymentIntent2(data) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('stripePaymentIntent2');
    let dataObject = {
      amount: data.amount,
      currency: data.currency,
      email: data.email,
      parentId: data.parentId,
      companyId: data.companyId,
      note: data.note,
      includeParent: data.includeParent,
      groupId: data.groupId,
      partnerId: data.partnerId,
      serviceId: data.serviceId,
      kidIds: data.kidIds,
      voucherCode: data.voucherCode,
      parentPhoneNo: data.parentPhoneNo,
      kidNames: data.kidNames,
      pathURL: data.pathURL,
      user: data.user,
      isAnonymous: data.isAnonymous,
      apikey: data.apikey,
      campus: data.campus,
      gradeApplying: data.gradeApplying,
      devision: data.devision,
      // subscription billing
      companyName: data.companyName,
      address: data.address,
      countryCode: data.countryCode,
      city: data.city,
      postalCode: data.postalCode,
      planId: data.planId,
      prevReservationId: data.prevReservationId
    };

    emailHttp(dataObject)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

export function stripeRefundIntent(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeRefundIntent');
    let dataObject = {
      amount: data.amount,
      paymentId: data.paymentId,
      reservationId: data.reservationId,
      phoneNumber: data.phoneNumber,
      email: data.email,
      note: data.note,
    };

    Http(dataObject)
      .then(function (result) {
        // Read result of the Cloud Function.
        var resData = result.data;
        resolve(resData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// stripe test refund
export function stripeRefundIntent2(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeRefundIntent2');
    let dataObject = {
      amount: data.amount,
      paymentId: data.paymentId,
      reservationId: data.reservationId,
      phoneNumber: data.phoneNumber,
      email: data.email,
      note: data.note,
    };

    Http(dataObject)
      .then(function (result) {
        // Read result of the Cloud Function.
        var resData = result.data;
        resolve(resData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// after refund send email to parent and partner
export function sendRefundEmail(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('reservationRefundEmail');
    let dataObject = {
      kidName: data.kidName,
      serviceName: data.serviceName,
      email: data.email,
      serviceId: data.serviceId,
      companyId: data.companyId,
      parentId: data.owner,
      partnerId: data.partnerId,
    };

    Http(dataObject)
      .then(function (result) {
        // Read result of the Cloud Function.
        var resData = result.data;
        resolve(resData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
};

// ======> STRIPE PLAN SUBSCRIPTION SECTION START

// stripe create setup intent for new customer to attach payment in  company-setting > billing
export function stripeSetupIntentNew(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeAddPaymentMethod');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
}

// stripe create setup intent for exist customer to attach new payment method in  company-setting > billing
export function stripeSetupIntentUpdate(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeUpdatePaymentMethod');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
}

// stripe delete payment method from partner in  company-setting > billing
export function deletePaymentMethod(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeDeletePaymentMethod');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data['message'];
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
}

// stripe get partner default payment method info
export function getDefaultPaymentMethod(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeGetDefaultPaymentMethod');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
}

// stripe create plan subscription for exist customerId
export function stripeCreatePlanSubscription(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeCreatePlanSubscriptionOnly');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
};

// stripe create plan subscription for new customer
export function stripeCreateCustomerAndSubscription(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeCreateCustomerAndSubscription');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
};

// stripe get clientSecret to repay for failed payment
export function stripeGetClientSecret(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeRetrivePayment');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
};

export function upgradeDowngradeSubscription(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('stripeUpgradeDowngradeSubscription');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data['message'];
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
};


export function sendContactusEmail(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('contactFormEmail');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data['message'];
        resolve(data);
      })
      .catch(function (error) {
        var message = error.message;
        reject(message);
      });
  });
};

// ======> STRIPE PLAN SUBSCRIPTION SECTION END

// mark reservation key payout as true from admin side
export function payoutReservation(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('reservationPayoutEvent');

    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var resData = result.data;
        resolve(resData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// Change start and end of reservation for selected in admin side
export function changeAdminStartEndDates(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('adminChangeReservationDates');

    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var resData = result.data;
        resolve(resData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// get company name list for admin reservation filter input field
function getCompanyList(countryCode) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getCompanies');

    http({ countryCode })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('company list error', error);
        var message = error;
        reject(message);
      });
  });
}

// get evs renew reservation
function evsRenewReservation(data) {
  return new Promise((resolve, reject) => {
    var evsRenewReservationHttp = functions.httpsCallable('evsRenewReservation');

    evsRenewReservationHttp(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// evsRenewReservation({companyId:'-NCHToDWkdwx9VCpr1g1',parentId:'ZdzbgVpz5Zg1USKpcMvbRuVUuzD3'})

// anonymous evs renew reservation for anonymous login
function anonymousRenewReservation(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('anonymousEvsRenewReservation');

    Http({ companyId: data.companyId, phoneNumber: data.pnum, reservationId: data.reservationId })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// get reservation
function getReservation(companyId,memberId) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('mobileCurrentReservation');

    Http({ companyId: companyId, memberId })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// get new desktop reservation
export function dsGetNewReservation(companyId,professionalMemberId) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('desktopNewReservation');
    Http({ companyId: companyId,...(professionalMemberId ? {professionalMemberId} : {}) })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// get schedule reservations
export function getScheduleReservations(dataObj) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('scheduleReservations');
    http(dataObj)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        let reversed = decompress(data);
        resolve(reversed);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// get new mobile reservation
export function getMBNewReservation(companyId,professionalMemberId) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('mobileNewReservation');

    Http({ companyId: companyId,...(professionalMemberId ? {professionalMemberId} : {}) })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// get reservation
export function dsGetReservation(companyId,memberId,sort) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('desktopCurrentReservation');
    Http({ companyId: companyId, memberId,sort })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

// get wallet parent list
function getParentList({searchType,searchText,companyId}) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getWalletParent');

    https({ searchType,searchText,companyId })
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// get categories for booking page add another service dialog
export function getBookingCategories(dataObj) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getCategoriesParent');

    https({...dataObj})
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

export function getLmsCategory({LmsDomain, token}) {
  console.log('getLmsCategory')
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('LMSGetCategories');

    emailHttp({ LmsDomain, token })
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data['categories']);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

export function getLmsCourses({LmsDomain, token, categoryId}) {
  console.log('LMSGetCourses')
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('LMSGetCourses');

    emailHttp({ LmsDomain, token, categoryId })
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data['courses']);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

export function getLmsClasses({LmsDomain, token,categoryId}) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('LMSGetClasses');

    emailHttp({ LmsDomain, token, categoryId })
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data['classes']);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

export function getReportReservation(dataObj) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getReportReservation');

    https(dataObj)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        let reversed = decompress(data);
        resolve(reversed);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// get subscriptions of reservation for partner
export function getReservationSubscriptions(dataObj) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getReservationSubscriptions');

    https(dataObj)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        let reversed = decompress(data);
        resolve(reversed);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

export function AddLMSDataManually({LmsDomain,courseId,reservation,LMSCompanyId, lmsStudentId, lmsStudentUsername, lmsStudentPassword}) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('AddLMSCredentialManual');

    emailHttp({ LmsDomain, courseId, reservation, LMSCompanyId, lmsStudentId, lmsStudentUsername, lmsStudentPassword })
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
};

export function LMSCreateStudent({LmsDomain,token,courseId,reservation,LMSCompanyId, parentRoleId, studentRoleId }) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('LMSCreateStudent');
    console.log('courseIdcourseId',courseId)

    emailHttp({ LmsDomain, token, courseId, reservation, LMSCompanyId, parentRoleId, studentRoleId })
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

export function LmsSuspendAccount({LmsDomain, token, studentLMSId,parentLMSId, reservation}) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('LmsSuspendAccount');

    http({LmsDomain, token, studentLMSId,parentLMSId, reservation})
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
};

export function newDomainEmail(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('newDomainBook');

    http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error?.message;
        reject(message);
      });
  });
};

// convert google map short url to embed
export function convertMapUrlToEmbed(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('convertMapShortUrlToEmbedUrl');

    http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error?.message;
        reject(message);
      });
  });
};

// update company activeStep
export function updateCompanyCurrentStep({companyId,eventName}) {
  if(companyId && eventName) {
    db.ref(`Companies/${companyId}/activeStep/`).set(eventName);
  };
};

async function aa(cc,planId) {
  const courseId = '-OI7sXqIQYP1WvEnBhoa';
  // var temps = await(await db.ref(`ActiveSubscriptions/`).orderByChild('companyId').equalTo('-OI7sXqIQYP1WvEnBhoa').once('value')).val();
  // console.log('reservations',temps)
  var temps = await(await db.ref(`ActiveSubscriptions/`).once('value')).val();


  // var contents = await(await db.ref(`CourseContents/`).orderByChild('courseId').equalTo(courseId).once('value')).val();
  // console.log('contents',contents)

  for(var i in temps) {
    console.log('subsriptionId==>',temps[i].id, temps[i].scheduleForDelete,'   compId==>',temps[i].companyId);
  //   const companyId= temps[i]?.companyId;
  //   const duration= temps[i]?.duration;
  //   console.log(`companyId==> ${companyId} duration==> ${duration}`);
  //   // db.ref(`Companies/${companyId}/billingCountryCode`).set(countryCode);
  }
  // var temps2 = await(await db.ref(`Reservations/`).orderByChild('owner').equalTo('7MeklgiKxdQBtJbdXVnnFk0Mshk2').once('value')).val();

  // var temps = await(await db.ref(`ActiveSubscriptions/`).orderByChild('companyId').equalTo('-OI28vxsTw43cuYdJ-tO').once('value')).val();
  // console.log('temps2',temps2)
};

// aa();

// add data to specific spreadsheet for form in website
export function processCustomFormData(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('processCustomFormData');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      console.log('response',response);
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

export function getCourseReport(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getCourseReport');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

export function shareCourseCertificate(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('sendCourseCertificate');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};
// remove parents all active sessions
export function revokeAllParentSessions(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('revokeAllParentSessions');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      console.log('response',response);
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

export function getCourseContent(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getCourseContent');

    http(data)
    .then(async (result)=> {
      // Read result of the Cloud Function.
      var response = result.data;
      let reversed = decompress(response);
      resolve(reversed || []);
    })
    .catch((error)=> {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

export function generateContentSignedUrl(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('generateContentSignedUrl');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var {url} = result.data;
      resolve(url);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

// IYZICO GATEWAY FUNCTIONS

export function iyzicoPaymentInitialize(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('iyzicoPaymentInitialize');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = JSON.parse(result.data);
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

// Tapfiliate start

// click Event
export function tapfiliateClickEvent(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('tapfiliateClickEvent');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

// Tapfiliate end

// ================================
// Revoult Subscription functions
export function createRevolutSubscriptions(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('createRevolutSubscriptions');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

export function partnerRevolutBuyStorage(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('revolutBuyStorage');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

// renew manually revolut subscriptions
export function createRenewRevolutSubscriptions(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('renewRevolutSubscription');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

export function cancelRevolutOrder(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('cancelRevolutOrder');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

export function getRevolutOrderDetails(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getRevolutOrderDetails');

    http(data)
    .then(function (result) {
      // Read result of the Cloud Function.
      var response = result.data;
      resolve(response);
    })
    .catch(function (error) {
      console.log('error', error);
      var message = error.message;
      reject(message);
    });
  });
};

// Revoult Subscription functions end
// ================================

// Extend EVS Company reservation endDate from partner current reservatopm
export function extendReservationDateEnd(data) {
  return new Promise((resolve, reject) => {
    var partnerHttp = functions.httpsCallable('extendReservationDateEnd');

    partnerHttp(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// send payment link via email on partner request
export function sendPaymentLink(data) {
  return new Promise((resolve, reject) => {
    var partnerHttp = functions.httpsCallable('sendPaymentLink');

    partnerHttp(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve();
      })
      .catch(function (error) {
        console.log('error', error);
        reject(error);
      });
  });
};


// get attendance for current reservation page
export function getAttendance(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getAttendance');

    http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// get groupings content submission tasks
export function getGroupingSubmissionTasks(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getGroupingSubmissionTasks');

    http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// update attendance
export function updateAttendance(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('updateAttendance');

    http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var status = result.data['status'];
        resolve(status);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

export function getLatestFiveReservation(companyId) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getLatestFiveReservation');

    http({companyId})
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

export function processBookingReservation(data) {
  return new Promise((resolve, reject) => {
    var partnerHttp = functions.httpsCallable('processReservation');

    partnerHttp(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        const status = result['data']['status'];
        const message = result['data']['message'];
        const type = result['data']['type'];
        const transactionId = result['data']?.['transactionId'] || '';
        resolve({message,status,type,transactionId});
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

export function processWalletBookingReservation(data) {
  return new Promise((resolve, reject) => {
    var partnerHttp = functions.httpsCallable('processWalletReservation');

    partnerHttp(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        const status = result['data']['status'];
        const message = result['data']['message'];
        const type = result['data']['type'];
        const transactionId = result['data']?.['transactionId'] || '';
        resolve({message,status,type,transactionId});
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

export function storeWalletRecord(data) {
  return new Promise((resolve, reject) => {
    var partnerHttp = functions.httpsCallable('storeWalletRecord');

    partnerHttp(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result['data']['status'];
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// create paypal subscription for partner
export function createPaypalSubscription(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('createPaypalSubscriptions');

    http(data)
      .then(function (result) {
        console.log('result',result);
        // Read result of the Cloud Function.
        var response = result['data'];
        resolve(response);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error?.message;
        reject(message);
      });
  });
};

// cancel paypal subscription 
export function cancelPaypalSubscription(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('cancelPaypalSubscription');

    http(data)
      .then(function (result) {
        console.log('result',result);
        // Read result of the Cloud Function.
        var message = result['data']['message'];
        console.log('message',message)
        resolve(message);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error?.message;
        reject(message);
      });
  });
};

export function getPaypalSubscriptionInfo(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('getPaypalSubscriptionDetails');

    http(data)
      .then(function (result) {
        console.log('result',result);
        // Read result of the Cloud Function.
        var response = result['data'];
        resolve(response);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

export async function checkCompanyPath(path) {
  return new Promise(async (resolve, reject) => {

    try{
      const idCompanyData = await (await db.ref(`Companies/${path}`).once('value')).val();
      const idExist = idCompanyData && idCompanyData['id'] ? idCompanyData['id'] : '';
      
      const urlCompanyData = await (await db.ref(`Companies/`).orderByChild('urlName').equalTo(path?.toLowerCase()).once('value')).val();
      const urlExist = urlCompanyData ? Object.keys(urlCompanyData)[0] : '';

      resolve(idExist ? idExist : urlExist);
    }
    catch(e) {
      reject(e.message)
    }
  });
}

export function disApproveReservation(bodyData) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('disApproveReservation');

    Http({...bodyData})
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// for partner member password change
function sendMsgEmail(msg, companyName, companyImage, parentIds) {
  return new Promise((resolve, reject) => {
    var emailHttp = functions.httpsCallable('SendMsgEmail');

    emailHttp({
      msg: msg,
      companyName: companyName,
      companyImage: companyImage,
      parentIds: parentIds,
    })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data.message;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// for partner member password change
function updateMemberPass(id, password) {
  return new Promise((resolve, reject) => {
    var partnerHttp = functions.httpsCallable('changeMemberPassword');

    partnerHttp({ uid: id, password: password })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data.message;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

function deletePartnerTeam(id) {
  return new Promise((resolve, reject) => {
    var partnerHttp = functions.httpsCallable('deletePartner');

    partnerHttp({ uid: id })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data.message;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

function addPartnerTeam(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('addPartnerMember');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data.message;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// create customer manually by partner in page /customers
export function addPartnerCustomerManually(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('createPartnerCustomer');
    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var res = result.data;
        resolve(res);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// update parent password for those whose cred
// is created by partner manually
export function updateParentPass(id, password) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('changeParentPassword');

    http({ uid: id, password: password })
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data.message;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// send customer credential via email
export function sendCustomerCredentials(data) {
  return new Promise((resolve, reject) => {
    var http = functions.httpsCallable('sendCustomerCredentials');

    http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var msg = result.data.message;
        resolve(msg);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// kashier generate hash
export function kashierGenerateHash(data) {
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('kashierOrderHashGenerate');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// hyperpay events
export function hyperPayCreateCheckout(data) {
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('hyperPayCreateCheckout');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = JSON.parse(result.data);
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// Paytabs
export function paytabsCreateOrder(data) {
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('paytabsCreateOrder');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = JSON.parse(result.data);
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// paytabs partner selynk subscription
export function paytabsPartnerSubscription(data) {
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('paytabsBuySubscription');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = JSON.parse(result.data);
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

export function paytabsPartnerBuyStorage(data) {
  console.log('paytabsPartnerBuyStorage called')
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('paytabsBuyStorage');
    httpCall(data)
      .then(function (result) {
        console.log('result',result)
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// get paytab transaction detail
export function getPaytabsTransactionDetails(data) {
  console.log('dddddd',data)
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('getPaytabsTransactionDetails');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = JSON.parse(result.data);
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
}

// paytabs partner selynk subscription renew
export function paytabsRenewSubscription(data) {
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('paytabsRenewSubscription');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};



// Tap payment function

// get order status for provided chargeId
export function getTapPaymentStatus(data) {
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('getTapChargeDetail');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

// create charge api for provided token
export function tapChargeOrder(data) {
  return new Promise((resolve, reject) => {
    var httpCall = functions.httpsCallable('tapChargeOrder');
    httpCall(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var data = result.data;
        resolve(data);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error.message;
        reject(message);
      });
  });
};

function addTrack(user, countryCode, changedTable, tableId, changeType) {
  return new Promise((resolve, reject) => {
    let date = Math.floor(new Date() / 1000);
    let obj = { user, date, countryCode, changedTable, tableId, changeType };
    db.ref('Tracks/')
      .push(obj)
      .then((suc) => {
        db.ref('Tracks/' + suc.key).update({ id: suc.key });
        resolve();
      })
      .catch((e) => {
        console.log('track error', e);
        reject();
      });
  });
}

// create new chatroom
export function createChatroom(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('createChatRoom');

    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var resData = result.data;
        resolve(resData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

export function postChatMessage(data) {
  return new Promise((resolve, reject) => {
    var Http = functions.httpsCallable('postChatMessage');

    Http(data)
      .then(function (result) {
        // Read result of the Cloud Function.
        var resData = result.data;
        resolve(resData);
      })
      .catch(function (error) {
        console.log('error', error);
        var message = error;
        reject(message);
      });
  });
}

function logIn(email, pwd) {
  return new Promise((resolve, reject) => {
    auth
      .signInWithEmailAndPassword(email, pwd)
      .then((user) => {
        firebase
          .database()
          .ref('Partners/' + user.user.uid)
          .once('value', (res) => {
            var data = res.val();
            if (!data) {
              // check for member
              firebase.database()
              .ref('PartnerTeams/' + user.user.uid)
              .once('value', (res) => {
                var data = res.val();
                if (!data || !data.enabled) {
                  reject('No account against this email.');
                } else {
                  data.id = user.user.uid;
                  data.type = 'partner';
                  data.member = true;
                  resolve(data);
                }
              })
              .catch((e) => {
                reject(e.message);
              });
            } else {
              data.id = user.user.uid;
              data.type = 'partner';
              resolve(data);
            }
          })
          .catch((e) => {
            reject(e.message);
          });
      })
      .catch((e) => {
        console.log('eeeeee',e)
        reject(e.message);
      });
  });
};


export function parentLogin(email, pwd) {
  return new Promise((resolve, reject) => {
    auth
      .signInWithEmailAndPassword(email, pwd)
      .then((user) => {
        firebase
          .database()
          .ref('Users/' + user.user.uid)
          .once('value', (res) => {
            var data = res.val();
            if (!data) {
              reject('No account against this email.');
              auth.signOut();
            } else {
              data.id = user.user.uid;
              data.isParent = true;
              resolve(data);
            }
          })
          .catch((e) => {
            reject(e.message);
            auth.signOut();
          });
      })
      .catch((e) => {
        reject(e.message);
      });
  });
};

export function parentSignup(obj,email,pwd) {
  return new Promise((resolve, reject) => {
    auth
      .createUserWithEmailAndPassword(email, pwd)
      .then(async (user) => {
        obj.id = user.user.uid;
        await db
          .ref('Users/' + user.user.uid)
          .set(obj)
          .then(() => {
              resolve(user?.user?.uid);
          })
          .catch((e) => {
            reject(e.message);
          });
      })
      .catch((e) => {
        reject(e.message);
      });
  });
};

// Admin login function
function AdminLogIn(email, pwd) {
  return new Promise((resolve, reject) => {
    auth
      .signInWithEmailAndPassword(email, pwd)
      .then((user) => {
        db.ref('Admins/' + user.user.uid)
          .once('value', (data) => {
            var adminData = data.val();
            if (!adminData) {
              reject('No account against this email.');
            } else {
              adminData.id = user.user.uid;
              resolve(adminData);
            }
          })
          .catch((e) => {
            reject(e.message);
          });
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// adding admin role function
function addAdmin(obj) {
  const { email, pwd, role } = obj;
  return new Promise((resolve, reject) => {
    auth
      .createUserWithEmailAndPassword(email, pwd)
      .then((user) => {
        db.ref('Admins/' + user.user.uid)
          .set({ email, id: user.user.uid, role })
          .then((suc) => {
            resolve();
          })
          .catch((e) => {
            reject(e.message);
          });
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// push kids
async function addKids(array) {
  return new Promise(async (resolve, reject) => {
    let array2 = array.map(async (v) => {
      return db
        .ref('Kids')
        .push({
          birthdate: v.birthdate,
          firstName: v.firstName,
          lastName: v.lastName,
          gender: v.gender,
          schoolName: v.schoolName,
          parentId: v.parentId,
        })
        .then(async suc => {
          db.ref('Kids/' + suc.key).update({ id: suc.key });
          v.kidId = suc.key;
          return v;
        })
        .catch((e) => {
          reject(e.message);
        });
    });
    await Promise.all(array2)
      .then(async suc => {
        resolve(suc);
      })
      .catch((err) => {
        reject(err.message);
      });
  });
}

async function addReservations(array) {
  array = array.filter((element) => cleanObject(element));
  return new Promise((resolve, reject) => {
    array.map((v) => {
      db.ref('Reservations/')
        .push(v)
        .then(suc => {
          db.ref('Reservations/' + suc.key).update({ id: suc.key });
          resolve('reservations send successfully');
        })
        .catch(e => {
          console.log('error in saving reservation', e);
          reject(e.message);
        });
    });
  });
};

export async function updateReservations(array) {
  array = array.filter((element) => cleanObject(element));
  return new Promise((resolve, reject) => {
    array.map((v) => {
      db.ref(`Reservations/${v.id}`)
        .update(v)
        .then(() => {
          resolve('reservations send successfully');
        })
        .catch(e => {
          console.log('error in saving reservation', e);
          reject(e.message);
        });
    });
  });
}

export async function savePaymentTransactions(transaction) {
  transaction = cleanObject(transaction);
  return new Promise(async (resolve, reject) => {
    var nodeId = (await db.ref('Transactions').push()).key;
    transaction.id = nodeId;
    db.ref(`Transactions/${nodeId}`)
      .set(transaction)
      .then(() => {
        resolve('Transcation successfully');
      })
      .catch(e => {
        console.log('error in saving transactions', e);
        reject(e.message);
      });
  });
}

export async function createGroup({companyId,currency,serviceId,groupPrice,name,assignMember}) {
  let data = {companyId,currency,groupType:'ticket',serviceId,groupPrice,name,assignMember,availableSeats:10,durationDays:10,totalSeats:10,groupStatus:'active',startDate:moment().unix(),endDate:moment(new Date().setDate(new Date().getDate()+28)).unix(),adult:true,kid:true};
  return new Promise(async (resolve, reject) => {
    var nodeId = (await db.ref('Groups').push()).key;
    data.id = nodeId;
    db.ref(`Groups/${nodeId}`)
      .set(data)
      .then(() => {
        resolve('Group created successfully');
      })
      .catch(e => {
        console.log('error in creating group', e);
        reject(e);
      });
  });
};

export async function saveWalletTransactions(transaction) {
  transaction = cleanObject(transaction);
  return new Promise(async (resolve, reject) => {
    var nodeId = (await db.ref('WalletTransactions').push()).key;
    transaction.id = nodeId;
    db.ref(`WalletTransactions/${nodeId}`)
      .set(transaction)
      .then(() => {
        resolve('wallet Transcation successfully');
      })
      .catch(e => {
        console.log('error in saving wallet transactions', e);
        reject(e.message);
      });
  });
}

function addSchoolReservations(array) {
  return new Promise((resolve, reject) => {
    array.forEach(async (v) => {
      var nodeId = (await db.ref('SchoolReservations').push()).key;
      v.id = nodeId;
      db.ref(`SchoolReservations/${nodeId}`)
        .set(v)
        .then(() => {
          resolve('reservations send successfully');
        })
        .catch(e => {
          console.log('error in saving reservation', e);
          reject(e.message);
        });
    });
  });
}

// Partner Signup function
function signup(obj, pwd) {
  return new Promise((resolve, reject) => {
    auth
      .createUserWithEmailAndPassword(obj.email, pwd)
      .then(async (user) => {
        obj.id = user.user.uid;
        await db
          .ref('Partners/' + user.user.uid)
          .set(obj)
          .then(() => {
            db.ref('Partners/' + user.user.uid)
              .once('value', (data) => {
                var partnerData = data.val();
                partnerData.id = user.user.uid;
                resolve(partnerData);
              })
              .catch((e) => {
                reject(e.message);
              });
          })
          .catch((e) => {
            reject(e.message);
          });
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// GET TEMPLATE DESIGN FROM `Config/Template/Design`
export function getTemplateDesign() {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Config/TemplateDesign/')
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          array = Object.values(allData).filter(val=> !val.disable);
          array = array.map((v, i) => ({
            ...v,
            title: `temp_ ${i === 0 ? 'default' : '0' + i}`,
          }));
          resolve(array);
        }
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// add company function
function addCompany(obj, logo, array) {
  var { owner, countryCode } = obj;
  return new Promise((resolve, reject) => {
    let storageRef = firebase
      .storage()
      .ref()
      .child(`CompanyAvatars/${logo.name}`);
    storageRef
      .put(logo)

      .then((url) => {
        url.ref.getDownloadURL().then((avatar) => {
          obj.avatar = avatar;
          db.ref('Companies/')
            .push(obj)
            .then((suc) => {
              db.ref('Companies/' + suc.key)
                .child('id')
                .set(suc.key);
              addTrack(owner, countryCode, 'Companies', suc.key, 'new');
              if (array.length > 0) {
                addPhotos(array, suc.key,suc.key);
              }
              resolve(suc.key);
            })
            .catch((er) => {
              reject('error in adding company');
            });
        });
      });
  });
}

// add activity function
function addActivity(obj, cover, array, userId, cc) {
  // var {companyId} = obj
  return new Promise((resolve, reject) => {
    let storageRef = firebase.storage().ref().child(`${obj?.companyId}/Covers/Services/${cover.name}`);
    storageRef
      .put(cover)

      .then((url) => {
        url.ref.getDownloadURL().then((cover) => {
          obj.cover = cover;
          db.ref('Services/')
            .push(obj)
            .then((suc) => {
              addTrack(userId, cc, 'Service', suc.key, 'new');
              db.ref('Services/' + suc.key).update({ id: suc.key });
              if (array.length > 0) {
                addPhotos(array, suc.key,obj?.companyId);
              }
              resolve(suc.key);
            })
            .catch((er) => {
              reject('error in adding company');
            });
        });
      });
  });
}

// add school function
function addSchool(obj, cover, userId) {
  var { countryCode } = obj;
  return new Promise((resolve, reject) => {
    let storageRef = firebase.storage().ref().child(`Covers/${cover.name}`);
    storageRef
      .put(cover)

      .then((url) => {
        url.ref.getDownloadURL().then((cover) => {
          obj.cover = cover;
          db.ref('Schools/')
            .push(obj)
            .then((suc) => {
              db.ref('Schools/' + suc.key)
                .child('id')
                .set(suc.key);
              addTrack(userId, countryCode, 'Schools', suc.key, 'new');
              resolve(suc);
            })
            .catch((er) => {
              reject('error in adding school');
            });
        });
      });
  });
}

// adding contact function
function addHomePage(array, countryId, userId, countryCode) {
  return new Promise((resolve, reject) => {
    array.map((data) => {
      db.ref(`Config/Categories/${countryId}`)
        .push(data)
        .then((suc) => {
          db.ref(`Config/Categories/${countryId}/${suc.key}`).update({
            id: suc.key,
          });
          addTrack(
            userId,
            countryCode,
            `Config/Categories/${countryId}`,
            suc.key,
            'new'
          );
          resolve('all data save');
        })
        .catch((e) => {
          reject(e.message);
        });
    });
  });
}

// adding contact function
function UpdateHomePage(obj, countryId, id) {
  return new Promise((resolve, reject) => {
    db.ref(`Config/Categories/${countryId}/${id}`)
      .update(obj)
      .then(() => {
        resolve('home page updated successfully');
      })
      .catch(e => {
        reject(e.message);
      });
  });
}

// adding contact function
function addContact(array, companyId) {
  return new Promise((resolve, reject) => {
    array.map((v) => {
      db.ref('Contacts/')
        .push({ name: v.name, phoneNumber: v.phoneNumber, companyId })
        .then(() => {
          resolve('all data save');
        })
        .catch(e => {
          reject('error in saving contacts', e.message);
        });
    });
  });
}

// sending message to All function
function messageToAll(msg, companyId, parentArray, senderId, serviceId, cc,sendEmail,sendSMS,smsMessage,groupId) {
  var time = Math.floor(Date.now() / 1000);
  return new Promise((resolve, reject) => {
    parentArray.map((v) => {
      db.ref('Messages/')
        .push({
          content: msg,
          time,
          companyId,
          parentId: v,
          senderId,
          receiverId: v,
          serviceId,
          groupId: groupId || '',
          read: false,
          sendEmail,
          sendSMS,
          smsMessage,
          isAnnouncement:true,

        })
        .then((suc) => {
          addTrack(senderId, cc, 'Messages', suc.key, 'new');
          db.ref('Messages/' + suc.key).update({
            id: suc.key,
            chatId: suc.key,
          });
          resolve('all data save');
        })
        .catch((e) => {
          reject('error in saving contacts', e.message);
        });
    });
  });
}

// processing photos array function
function addPhotos(array, id,companyId) {
  for (var i = 0; i < array.length; i++) {
    var imageFile = array[i];

    var a = uploadImageAsPromise(imageFile, id,companyId);

    a.then(() => {}).catch((e) => {});
  }
}

//Handle waiting to upload each image file using promise function
function uploadImageAsPromise(imageFile, id, companyId) {
  return new Promise(function (resolve, reject) {
    let name = generateId();
    var storageRef = firebase.storage().ref(`${companyId}Albums/${id}/${name}`);

    //Upload file
    var task = storageRef.put(imageFile);

    //Update progress bar
    task.on(
      'state_changed',
      function progress(snapshot) {},
      function error(err) {},
      function complete() {
        storageRef.getDownloadURL().then(function (url) {
          db.ref('Photos/')
            .push({ owner: id, photoPath: url })
            .then((suc) => {
              db.ref('Photos/' + suc.key).update({ id: suc.key });
              resolve(url);
            })
            .catch((e) => {
              console.log('error', e);
              reject(e.message);
            });
        });
      }
    );
  });
}

// add Branches function
function addBranch(array, companyId) {
  return new Promise((resolve, reject) => {
    array.map((v) => {
      db.ref('Branches/')
        .push({
          name: v.name,
          phoneNumber: v.phoneNumber,
          latitude: v.latitude,
          longitude: v.longitude,
          companyId: companyId,
          countryCode: v.countryCode,
        })
        .then((suc) => {
          db.ref('Branches/' + suc.key)
            .child('id')
            .set(suc.key);
          resolve('all data save');
        })
        .catch((e) => {
          reject('error in saving contacts', e.message);
        });
    });
  });
}

// add videos function
function addVideo(array, serviceId) {
  return new Promise((resolve, reject) => {
    array.map((v) => {
      db.ref('Videos/')
        .push({ videoPath: v, owner: serviceId })
        .then((suc) => {
          db.ref('Videos/' + suc.key)
            .child('id')
            .set(suc.key);
          resolve('all data save');
        })
        .catch((e) => {
          reject('error in saving video', e.message);
        });
    });
  });
}

// updating videos function
function updateVideo(array, serviceId) {
  return new Promise((resolve, reject) => {
    array.map((v) => {
      db.ref('Videos/')
        .push({ videoPath: v.videoPath, owner: serviceId })
        .then((suc) => {
          db.ref('Videos/' + suc.key)
            .child('id')
            .set(suc.key);
          resolve('all data save');
        })
        .catch((e) => {
          reject('error in saving video', e.message);
        });
    });
  });
};

// admin get all company record
export function allCompany(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getAdminCompanyRecord');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('allCompany error: ', error);
        reject(error);
      });
  });
};

// get quiz report
export function getQuizResults(data) {
  return new Promise((resolve, reject) => {
    var https = functions.httpsCallable('getQuizResults');

    https(data)
      .then(function (result) {
        var responseData = result.data;
        resolve(responseData);
      })
      .catch(function (error) {
        console.log('get quiz error: ', error);
        reject(error);
      });
  });
};

// getting activities function
function allActivity() {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Services/')
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          for (var i in allData) {
            allData[i].activityId = i;
            array.push(allData[i]);
          }
        }
        resolve(array);
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// getting schools function
function allSchool() {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Schools/')
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          for (var i in allData) {
            allData[i].schoolId = i;
            array.push(allData[i]);
          }
        }
        resolve(array);
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// getting company "Query by companyId" function
function getCompanyById(id) {
  let a = {};
  return new Promise((resolve, reject) => {
    db.ref('Companies/')
      .orderByChild('id')
      .equalTo(id)
      .once('value', (data) => {
        var allData = data.val();
        if (!allData) {
          reject('No company found');
        }
        if (allData) {
          Object.keys(allData).map((v) => {
            allData[v].companyId = v;
            a = allData[v];
          });
          if (a.countryCode) {
            resolve(a);
          } else {
            reject();
          }
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
}

// getting company "Query by onwer" function
function specificCompanyById(id) {
  let a = {};
  return new Promise((resolve, reject) => {
    db.ref('Companies/').orderByChild('owner').equalTo(id).once('value', (data) => {
        var allData = data.val();
        if (!allData) {
          reject('No user found');
        }
        if (allData) {
          Object.keys(allData).map((v) => {
            allData[v].companyId = v;
            a = allData[v];
          });
          if (a.countryCode) {
            resolve(a);
          } else {
            reject();
          }
        }
      })
      .catch((e) => {
        console.log('eeee',e)
        reject(e);
      });
  });
}

// getting activities "Query by countryCode" function
function specificActivity(countryCode) {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Services/')
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          for (var i in allData) {
            if (allData[i].countryCode === countryCode) {
              allData[i].activityId = i;
              array.push(allData[i]);
            }
          }
        }
        resolve(array);
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// getting schools "Query by countryCode" function
function specificSchool(countryCode) {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Schools/')
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          for (var i in allData) {
            if (allData[i].countryCode === countryCode) {
              allData[i].schoolId = i;
              array.push(allData[i]);
            }
          }
        }
        resolve(array);
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// getting activities "Query by companyId" function
function specificActivityById(id) {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Services/')
      .orderByChild('companyId')
      .equalTo(id)
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          for (var i in allData) {
            if(!allData[i].archive && !allData[i].courses) {
              allData[i].activityId = i;
              array.push(allData[i]);
            }
          }
        }
        resolve(array);
      })
      .catch((e) => {
        console.log('error in getting activity specific Record by comp id');
        reject(e.message);
      });
  });
}

// getting schools "Query by companyId" function
function specificSchoolById(id) {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Schools/')
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          for (var i in allData) {
            if (allData[i].companyId === id) {
              allData[i].schoolId = i;
              array.push(allData[i]);
            }
          }
        }
        resolve(array);
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// getting tags function
function getTag(name, cc) {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref(`Config/Categories/${cc}/`)
      .orderByChild('key')
      .equalTo(name)
      .once('value', (res) => {
        var data = res.val();
        if (!data) {
          reject('no tags found for this category');
        } else {
          Object.keys(data).forEach((v) => {
            array.push(data[v].tags);
          });
          array = array.flat();
          resolve(array);
        }
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// getting reservation lengths "Query by companyId" function
function reservationLength(id) {
  var array = [];
  return new Promise((resolve, reject) => {
    db.ref('Reservations/')
      .orderByChild('companyId')
      .equalTo(id)
      .once('value', (data) => {
        var allData = data.val();
        for (var i in allData) {
          array.push(allData[i]);
          // if (allData[i].status === 'waiting') {
          // }
        }
        resolve(array.length);
      });
  });
}

// getting reservations "Query by companyId && status=== 'waiting" function
function approveReservation(id) {
  var array = [];
  return new Promise((resolve, reject) => {
    db.ref('Reservations/')
      .orderByChild('companyId')
      .equalTo(id)
      .once('value', (data) => {
        var allData = data.val();
        for (var i in allData) {
          if (allData[i].status === 'waiting') {
            array.push(allData[i]);
          }
        }
        resolve(array.length);
      });
  });
}

// getting review length "Query by partnerId" function
function reviewLength(id) {
  var array = [];
  return new Promise((resolve, reject) => {
    db.ref('Reviews/')
      .orderByChild('partnerId')
      .equalTo(id)
      .once('value', (data) => {
        var allData = data.val();
        for (var i in allData) {
          array.push(allData[i]);
        }
        resolve(array.length);
      });
  });
}

// getting activities lengths "Query by companyId" function
function serviceLength(id) {
  var array = [];
  return new Promise((resolve, reject) => {
    db.ref('Services/')
      .orderByChild('companyId')
      .equalTo(id)
      .once('value', (data) => {
        var allData = data.val();
        for (var i in allData) {
          array.push(allData[i]);
        }
        resolve(array.length);
      });
  });
}

// getting current reservations lengths "Query by companyId" function
export function currentResLength(id) {
  let array = [];
  return new Promise((resolve, reject) => {
    db.ref('Reservations/')
      .orderByChild('companyId')
      .equalTo(id)
      .once('value', (data) => {
        var allData = data.val();
        if (allData) {
          array = Object.values(allData).filter((v) => v.status === 'waiting');
        }
        resolve(array.length);
      });
  });
}

// editing photos function
function editPhotos(array, id, companyId) {
  for (var i = 0; i < array.length; i++) {
    var imageFile = array[i].image;
    var a = uploadImageAsPromise(imageFile, id,companyId);
    a.then(() => {}).catch((e) => {});
  }
}

// updating acitivity function
function updateActivity(obj, cover, array, coverLink, id, userId, cc) {
  return new Promise((resolve, reject) => {
    if (cover.name) {
      let storageRef = firebase.storage().ref().child(`${obj?.companyId}/Covers/Services/${cover.name}`);
      storageRef
        .put(cover)

        .then((url) => {
          url.ref.getDownloadURL().then((cover) => {
            obj.cover = cover;
            db.ref('Services/' + id)
              .update(obj)
              .then(() => {
                addTrack(userId, cc, 'Services', id, 'update');
                if (array.length > 0) {
                  editPhotos(array, id,obj?.companyId);
                }
                resolve(id);
              });
          });
        })
        .catch((er) => {
          reject('error in update activity');
        });
    } else {
      obj.cover = coverLink;
      db.ref('Services/' + id)
        .update(obj)
        .then(() => {
          addTrack(userId, cc, 'Services', id, 'update');
          if (array.length > 0) {
            editPhotos(array, id,obj?.companyId);
          }
          resolve(id);
        })
        .catch((er) => {
          console.log('error', er);
          reject('error in updating activity');
        });
    }
  });
}

// update school function
function updateSchool(obj, cover, coverLink, id, userId) {
  let { countryCode } = obj;
  return new Promise((resolve, reject) => {
    if (cover.name) {
      let storageRef = firebase.storage().ref().child(`Covers/${cover.name}`);
      storageRef
        .put(cover)

        .then((url) => {
          url.ref.getDownloadURL().then((cover) => {
            obj.cover = cover;
            db.ref('Schools/' + id)
              .update(obj)
              .then((suc) => {
                addTrack(userId, countryCode, 'Schools', id, 'update');
                resolve(suc);
              })
              .catch((e) => {
                reject(e.message);
              });
          });
        })
        .catch((er) => {
          reject('error in update school');
        });
    } else {
      obj.cover = coverLink;
      db.ref('Schools/' + id)
        .update(obj)
        .then((suc) => {
          addTrack(userId, countryCode, 'Schools', id, 'update');
          resolve(suc);
        })
        .catch((er) => {
          reject('error in updating school');
        });
    }
  });
}

// generating randomId function
function generateId() {
  var result = '';
  var length = 15;
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// update company function
function updateCompany(obj, logo, array, avatar, id) {
  let { owner, countryCode } = obj;
  return new Promise((resolve, reject) => {
    if (logo.name) {
      let storageRef = firebase
        .storage()
        .ref()
        .child(`CompanyAvatars/${logo.name}`);
      storageRef
        .put(logo)

        .then((url) => {
          url.ref.getDownloadURL().then((avatar) => {
            obj.avatar = avatar;
            db.ref('Companies/' + id)
              .update(obj)
              .then(() => {
                addTrack(owner, countryCode, 'Companies', id, 'update');
                if (array.length > 0) {
                  editPhotos(array, id, id);
                }
                resolve(id);
              })
              .catch((er) => {
                reject('error in updating company');
              });
          });
        });
    } else {
      obj.avatar = avatar;
      db.ref('Companies/' + id)
        .update(obj)
        .then(() => {
          addTrack(owner, countryCode, 'Companies', id, 'update');
          if (array.length > 0) {
            editPhotos(array, id,id);
          }
          resolve(id);
        })
        .catch((er) => {
          reject('error in updating company');
        });
    }
  });
}

// add group function
async function addGroup(obj, userId, cc) {
  return new Promise(async (resolve, reject) => {
    var nodeId = (await db.ref('Groups').push()).key;
    obj.id = nodeId;
    db.ref(`Groups/${nodeId}`)
      .set(obj)
      .then(() => {
        addTrack(userId, cc, 'Groups', nodeId, 'new');
        resolve({groupId:nodeId});
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// update group function
function updateGroup(obj, id, userId, cc) {
  return new Promise((resolve, reject) => {
    db.ref('Groups/' + id)
      .update(obj)
      .then(() => {
        addTrack(userId, cc, 'Groups', id, 'update');
        resolve();
      })
      .catch((e) => {
        reject(e.message);
      });
  });
};

// add schedule function
export async function addSchedule(obj, userId, cc) {
  return new Promise(async (resolve, reject) => {
    var nodeId = (await db.ref('Schedules').push()).key;
    obj.id = nodeId;
    db.ref(`Schedules/${nodeId}`)
      .set(obj)
      .then(() => {
        addTrack(userId, cc, 'Schedules', nodeId, 'new');
        resolve({scheduleId:nodeId});
      })
      .catch((e) => {
        reject(e.message);
      });
  });
};

// update schedule function
export function updateSchedule(obj, id, userId, cc) {
  return new Promise((resolve, reject) => {
    db.ref('Schedules/' + id)
      .update(obj)
      .then(() => {
        addTrack(userId, cc, 'Schedules', id, 'update');
        resolve();
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// get report function
function getReport(id) {
  return new Promise((resolve, reject) => {
    db.ref('Reports')
      .orderByChild('owner')
      .equalTo(id)
      .once('value', (res) => {
        var data = res.val();
        if (!data) {
          reject('no data');
        } else if (data) {
          var actualData =
            data[Object.keys(data)[Object.keys(data).length - 1]];
          resolve(actualData);
        }
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// get msg list function
function getMsj(id) {
  return new Promise((resolve, reject) => {
    let array = [];
    db.ref('Messages')
      .orderByChild('companyId')
      .equalTo(id)
      .once('value', (res) => {
        var data = res.val();
        for (var i in data) {
          array.push(data[i]);
        }
        array.sort(function (a, b) {
          return a.parentId - b.parentId;
        });
        for (var j = 0; j < array.length - 1; j++) {
          if (array[j].parentId === array[j + 1].parentId) {
            delete array[j];
          }
        }
        array = array.filter(function (el) {
          return typeof el !== 'undefined';
        });
        array.sort(function (a, b) {
          return b.time - a.time;
        });
        var array2 = _.uniqBy(array, 'parentId');
        resolve(array2);
      });
  });
}

// dashboard msg function
function dashboardMsj(id) {
  return new Promise((resolve, reject) => {
    let array = [];
    db.ref('Messages')
      .orderByChild('companyId')
      .equalTo(id)
      .once('value', (res) => {
        var data = res.val();
        if (!data) {
          reject();
        } else {
          for (var i in data) {
            if (!data[i].read) {
              array.push(data[i]);
            }
          }
          array.sort(function (a, b) {
            return a.parentId - b.parentId;
          });

          for (var j = 0; j < array.length - 1; j++) {
            if (array[j].parentId === array[j + 1].parentId && array[j].read) {
              delete array[j];
            }
          }
          array = array.filter(function (el) {
            return typeof el !== 'undefined';
          });

          for (var k = 0; k < array.length; k++) {
            if (array[k].receiverId === array[k].parentId) {
              delete array[k];
            }
          }
          array = array.filter(function (el) {
            return typeof el !== 'undefined';
          });

          for (var l = 0; l < array.length - 1; l++) {
            if (array[l].parentId === array[l + 1].parentId) {
              delete array[l];
            }
          }

          array = array.filter(function (el) {
            return typeof el !== 'undefined';
          });

          resolve(array);
        }
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// send msj function
function sendMsjToDb(
  content,
  companyId,
  parentId,
  senderId,
  receiverId,
  serviceId,
  chatId,
  countryCode
) {
  var time = Math.floor(Date.now() / 1000);
  const message = {
    content,
    time,
    companyId,
    parentId,
    senderId,
    receiverId,
    serviceId,
    read: false,
  };

  return db
    .ref('Messages/')
    .push(message)
    .then((suc) => {
      db.ref('Messages/' + suc.key)
        .child('id')
        .set(suc.key);
      if (chatId) {
        db.ref('Messages/' + suc.key)
          .child('chatId')
          .set(chatId);
      } else {
        db.ref('Messages/' + suc.key)
          .child('chatId')
          .set(suc.key);
      }
      addTrack(senderId, countryCode, 'Messages', suc.key, 'new');
    });
}

// user-list "Query by countryCode" function
function specificAdminUser(cc) {
  return new Promise((resolve, reject) => {
    var array = [];
    db.ref('Users/')
      .orderByChild('countryCode')
      .equalTo(cc)
      .once('value', (res) => {
        var data = res.val();
        for (var i in data) {
          array.push(data[i]);
        }
        resolve(array.length);
      })
      .catch((e) => {});
  });
}

// partner-list "Query by countryCode" function
function specificAdminPartner(cc) {
  return new Promise((resolve, reject) => {
    var array = [];
    db.ref('Partners/')
      .orderByChild('countryCode')
      .equalTo(cc)
      .once('value', (res) => {
        var data = res.val();
        for (var i in data) {
          array.push(data[i]);
        }
        resolve(array.length);
      })
      .catch((e) => {
        console.log('e', e);
      });
  });
}

// company "Query by countryCode" function
function specificAdminComp(cc) {
  return new Promise((resolve, reject) => {
    var array = [];
    db.ref('Companies/')
      .orderByChild('countryCode')
      .equalTo(cc)
      .once('value', (res) => {
        var data = res.val();
        for (var i in data) {
          array.push(data[i]);
        }
        resolve(array.length);
      })
      .catch((e) => {});
  });
}

// activity-list "Query by countryCode" function
function specificAdminAct(cc) {
  return new Promise((resolve, reject) => {
    var array = [];
    db.ref('Services/')
      .orderByChild('countryCode')
      .equalTo(cc)
      .once('value', (res) => {
        var data = res.val();
        for (var i in data) {
          array.push(data[i]);
        }
        resolve(array.length);
      })
      .catch((e) => {});
  });
}

// categories list function
function catTags() {
  return new Promise((resolve, reject) => {
    var array = [];
    db.ref('Categories/')
      .once('value', (res) => {
        var data = res.val();
        for (var i in data) {
          array.push(data[i]);
        }
        resolve(array);
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

// getting categories "Query by id" function
function specTags(id) {
  return new Promise((resolve, reject) => {
    var array = [];
    db.ref('Categories/' + id)
      .once('value', (res) => {
        var data = res.val();
        array.push(data);
        resolve(array);
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}

export function cleanObject(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}

export default firebase;
export {
  auth,
  fsdb,
  db,
  logIn,
  AdminLogIn,
  signup,
  addKids,
  addAdmin,
  addPartnerTeam,
  deletePartnerTeam,
  addCompany,
  addContact,
  addHomePage,
  UpdateHomePage,
  messageToAll,
  addBranch,
  getTag,
  addActivity,
  addReservations,
  paymentIntent,
  allActivity,
  specificActivity,
  addGroup,
  updateCompany,
  getReservation,
  getParentList,
  updateActivity,
  getCompanyById,
  specificCompanyById,
  reservationLength,
  approveReservation,
  serviceLength,
  specificActivityById,
  updateGroup,
  addSchool,
  sendMsgEmail,
  specificSchoolById,
  updateSchool,
  allReservation,
  newSpecificReservation,
  getMsj,
  sendMsjToDb,
  getReport,
  dashboardMsj,
  reviewLength,
  addVideo,
  updateVideo,
  updateMemberPass,
  specificAdminUser,
  specificAdminPartner,
  specificAdminComp,
  specificAdminAct,
  catTags,
  specTags,
  generatePartnerReport,
  allSchool,
  specificSchool,
  addTrack,
  deleteZoomMeeting,
  createNewZoomClass,
  setReservationDates,
  evsRenewReservation,
  anonymousRenewReservation,
  getCompanyList,
  addSchoolReservations,
};
